<div ng-controller="SynchronizationSettingsController as synchronizationSettingsCtrl">
    <c-auto-form config="synchronizationSettingsCtrl.autoFormConfig"></c-auto-form>
</div>